import Model from 'src/storage/base';

class AdminEditAppointmentModel extends Model {
  id = 'AdminEditAppointmentModel';

  apiConfig = {
    doctor_detail: {
      url: 'doctor/detail',
      validation: {
        username: 'string'
      },
      cancellable: true
    },
    updateAnswers: {
      url: '/admin/appointment/update/answers',
      validation: {
        appointmentId: 'string',
        disease: 'disease',
        symptoms: 'symptoms',
        answers: 'answersanswers'
      },
      cancellable: true
    },
    appointmentDetail: {
      url: '/admin/appointment/detail',
      validation: {
        id: 'string'
      },
      cancellable: true
    }
  };
  _events = {
    profile: 'handleProfile'
  };

  handleProfile = (profile) => {
    this.setState({ user: profile });
  };
  loadDetail = (id, cb) => {
    this.setState({ appointment: null, files: [] });
    this.api('appointmentDetail', { id }, (error, appointment) => {
      this.setState({ appointment });
      cb(error, appointment);
    });
  };
  updateAnswers = (appointment, cb) => {
    this.api(
      'updateAnswers',
      {
        doctorId: appointment.doctor.id,
        appointmentId: appointment.id,
        disease: appointment.data.disease || '',
        symptoms: appointment.data.symptoms || '',
        answers: appointment.data.answers || [],
        media: appointment.media || [],
        files: this.state.files
      },
      (err, res, success) => {
        if (success) {
          this.setState({ detail: appointment });
        }
        cb && cb(err, res, success);
      }
    );
  };
}

const model = new AdminEditAppointmentModel();
export default model;
